export enum MailCode {
    WLC = 'Welcome',
    RUP = 'Ramp up period',
    LDIS = 'Lower discount',
    HDIS = 'Higher discount',
    TDIS = 'Top discount'
}